import BusinessActivitiesList from "./BusinessActivitiesList";

const BusinessActivitiesSetupPage = () => <BusinessActivitiesList />;

export default BusinessActivitiesSetupPage;
